<template>
	<v-container fluid grid-list-lg class="pa-3">
		<v-layout row wrap>
			<v-flex>
				<v-card>
					<v-toolbar dense prominent dark class="warning">
						<v-toolbar-title>FPES Report Listing</v-toolbar-title>
						<v-spacer></v-spacer>

						<v-toolbar-items>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn color="deep-purple accent-1" small fab v-on="on" href="/FPES-report?uuid=11c6e519-a679-4c24-89c9-c57cb3b94645">
										<v-icon>add_circle_outline</v-icon>
									</v-btn>
								</template>
								<span>Create new FPES Report</span>
							</v-tooltip>
						</v-toolbar-items>
					</v-toolbar>

					<v-card-text class="pa-0">
						<v-data-table dark :pagination.sync="table.pagination"
							:rows-per-page-items="table.rows_per_page_items"
							:total-items="table.total_items"
							:headers="table.headers.filter(r => r.viewable == true)"
							:loading="table.loading"
							:items="table.items">
							<template v-slot:items="props">
								<td class="px-0">
									<v-menu bottom right>
										<template v-slot:activator="{ on }">
											<v-btn small icon v-on="on">
												<v-icon color="deep-purple accent-1">more_vert</v-icon>
											</v-btn>
										</template>

										<v-list dense class="pa-0">
											<v-list-tile :href="'FPES-report?uuid=11c6e519-a679-4c24-89c9-c57cb3b94645&_id=' + props.item._id">
												<v-list-tile-action>
													<v-icon>edit</v-icon>
												</v-list-tile-action>
												<v-list-tile-title>Edit</v-list-tile-title>
											</v-list-tile>
											<v-list-tile :href="'FPES-report-hr?uuid=c81d0884-1b48-4a88-bdc9-506d4e20eb3e&_id=' + props.item._id">
												<v-list-tile-action>
													<v-icon>text_snippet</v-icon>
												</v-list-tile-action>
												<v-list-tile-title>HR Report</v-list-tile-title>
											</v-list-tile>
										</v-list>
									</v-menu>
								</td>
								<td>{{ epoch2localedatetime(props.item.created) }}</td>
								<td>{{ props.item.created_by }}</td>
								<td>{{ epoch2localedatetime(props.item.modified) }}</td>
								<td>{{ props.item.modified_by }}</td>
								<td>{{ props.item.start_date }}</td>
								<td>{{ props.item.end_date }}</td>
								<td>{{ props.item.total_emps }}</td>
								<td>{{ props.item.top_rate }}</td>
								<td>{{ props.item.bottom_rate }}</td>
								<td>{{ props.item.report_label }}</td>
								<td>{{ props.item.description }}</td>
								<td>{{ props.item.status }}</td>
							</template>
						</v-data-table>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import query_builder from "../../functions/query.builder";
import general from "../../functions/general";

export default {
	name: "FPES-Report-Listing",
	computed: {},
	mounted() {
		general.App.set_page_title("mySuite : FPES Report Listing");
	},
	watch: {
		"table.pagination": {
			handler: function () {
				this.reload_table();
			},
			deep: true
		},
	},
	data() {
		return {
			table: {
				headers: [
					{
						text: "",
						value: "",
						align: "left",
						sortable: false,
						viewable: true,
						type: "Number",
						class: "px-0",
						width: "30px"
					},
					{
						text: "ID",
						value: "_id",
						align: "left",
						sortable: false,
						viewable: false,
						type: "Number",
						class: "",
						width: ""
					},
					{
						text: "Created",
						value: "created",
						align: "left",
						sortable: true,
						viewable: true,
						type: "DateTime",
						class: "font-weight-black",
						width: ""
					},
					{
						text: "Created By",
						value: "created_by",
						align: "left",
						type: "String",
						sortable: true,
						viewable: true,
						class: "font-weight-black",
						width: ""
					},
					{
						text: "Modified",
						value: "modified",
						align: "left",
						sortable: true,
						viewable: true,
						type: "DateTime",
						class: "font-weight-black",
						width: ""
					},
					{
						text: "Modified By",
						value: "modified_by",
						align: "left",
						type: "String",
						sortable: true,
						viewable: true,
						class: "font-weight-black",
						width: ""
					},
					{
						text: "Start Date",
						value: "start_date",
						align: "left",
						sortable: true,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: ""
					},
					{
						text: "End Date",
						value: "end_date",
						align: "left",
						sortable: true,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: ""
					},
					{
						text: "total Emps",
						value: "total_emps",
						align: "left",
						sortable: true,
						viewable: true,
						type: "Number",
						class: "font-weight-black",
						width: ""
					},
					{
						text: "Top Rate",
						value: "top_rate",
						align: "left",
						sortable: true,
						viewable: true,
						type: "Number",
						class: "font-weight-black",
						width: ""
					},
					{
						text: "Bottom Rate",
						value: "bottom_rate",
						align: "left",
						sortable: true,
						viewable: true,
						type: "Number",
						class: "font-weight-black",
						width: ""
					},
					{
						text: "Report Label",
						value: "report_label",
						align: "left",
						type: "String",
						sortable: false,
						viewable: true,
						class: "font-weight-black",
						width: ""
					},
					{
						text: "Description",
						value: "description",
						align: "left",
						type: "String",
						sortable: false,
						viewable: true,
						class: "font-weight-black",
						width: ""
					},
					{
						text: "Status",
						value: "status",
						align: "left",
						type: "String",
						sortable: true,
						viewable: true,
						class: "font-weight-black",
						width: ""
					},
				],
				items: [],
				total_items:0,
				rows_per_page_items: [25, 50, 100, 200, 1000],
				loading: false,
				pagination: {
					descending: true,
					page: 1,
					rowsPerPage: 25,
					sortBy: "created",
					totalItems: 100
				},
			},
		};
	},
	methods: {
		epoch2localedatetime: general.App.epoch2LocaleDatetime,
		async reload_table() {
			this.table.loading = true;
			var qb = new query_builder.QueryBuilder();

			qb.Table = "fpes_report_view";
			qb.Limit = this.table.pagination.rowsPerPage;
			qb.Offset = this.table.pagination.page;

			// must check sortBy before push in order array
			if (this.table.pagination.sortBy) {
				qb.Order = [
					{
						name: this.table.pagination.sortBy,
						descending: this.table.pagination.descending,
					}
				];
			}

			var res = await general.wBackEndComm.PostData("process_arango_qb/", qb);
			res = res.data;
			if (res.Status == 1) {
				this.table.items = res.Body[0].records;
				this.table.total_items = res.Body[0].total_records;
			} else {
				general.wMsgBox.Error(res.Description);
			}

			this.table.loading = false;
		},
	},
};
</script>

<style></style>

